<template>
  <div class="page-container">
    <div class="order-list">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished && list.length > 0"
          :finished-text="list.length > 0 ? '没有更多了' : ''"
          :immediate-check="true"
          @load="onLoad"
        >
          <div
            class="order-card"
            v-for="(item, index) in list"
            :key="item.orderNo || index"
            @click="goToDetail(item)"
          >
            <div class="card-header">
              <span class="header-label">设备编号 {{ item.sn }}</span>
              <span class="status-text" :class="item.statusColorClass">
                {{ item.statusName }}
              </span>
            </div>

            <div class="card-body">
              <div class="img-box">
                <img src="@/assets/yjdd.png" alt="设备图" />
              </div>

              <div class="info-box">
                <div class="row-deposit">
                  <span class="label">押金</span>
                  <span class="amount">
                    ¥{{ Number(item.depositAmount).toFixed(2) }}
                  </span>
                </div>
                <div class="row-term">免押期限：{{ item.validityDays }}月</div>
              </div>
            </div>
          </div>
        </van-list>

        <div
          v-if="finished && list.length === 0 && !loading"
          class="empty-container"
        >
          <img class="empty-icon" src="@/assets/empty-order.png" />
          <div class="empty-text">暂无订单</div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { getListofUnsecuredOrders } from "@/api/user";

export default {
  data() {
    return {
      list: [],
      // 分页状态
      loading: false,
      finished: false,
      refreshing: false, // 下拉刷新的状态
      pageIndex: 1,
      pageSize: 10,
    };
  },

  methods: {
    // 上拉加载更多
    onLoad() {
      // 如果是下拉刷新触发的，重置页码
      if (this.refreshing) {
        this.pageIndex = 1;
      }
      this.getFreeList();
    },

    // 下拉刷新
    onRefresh() {
      // 1. 重置结束状态，保证可以重新加载
      this.finished = false;
      // 2. 将 loading 设置为 true，让 van-list 认为正在加载，配合 onLoad 逻辑
      this.loading = true;
      // 3. 触发加载
      this.onLoad();
    },

    goToDetail(item) {
      this.uni.navigateTo("/home/depositFreeDetail?orderNo=" + item.orderNo);
    },

    getFreeList() {
      const params = {
        index: this.pageIndex,
        pageSize: this.pageSize,
      };

      getListofUnsecuredOrders(params)
        .then((res) => {
          let newItems = res.list || [];

          // --- 数据清洗 ---
          newItems.forEach((item) => {
            if (item.status === 2 || item.statusName === "免押中") {
              item.statusColorClass = "status-green";
            } else {
              item.statusColorClass = "status-gray";
            }
            item.sn = item.sn || "未知设备";
            item.depositAmount = item.depositAmount || 0;
            item.validityDays = item.validityDays || 0;
          });

          // --- 核心分页逻辑 ---
          if (this.refreshing) {
            // 如果是下拉刷新，直接覆盖列表
            this.list = newItems;
            this.refreshing = false; // 关闭下拉刷新状态
          } else {
            // 如果是上拉加载，追加列表
            this.list = this.list.concat(newItems);
          }

          // 本次加载结束
          this.loading = false;

          // 判断是否还有下一页
          if (newItems.length < this.pageSize) {
            this.finished = true;
          } else {
            // 只有在数据满页时，才让页码 +1
            this.pageIndex++;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.refreshing = false;
          this.finished = true;
          console.error(err);
        });
    },
  },
};
</script>

<style lang="less" scoped>
/* 保持原有样式不变 */
.page-container {
  min-height: 100vh;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
}

.order-list {
  padding: 24px 24px 0;
}

.order-card {
  background: #fff;
  padding: 0 32px;
  margin-bottom: 20px;
  border-radius: 16px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
}

.card-header {
  height: 90px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-label {
  font-size: 30px;
  color: #848992;
}

.status-text {
  font-size: 28px;
}

.status-green {
  color: #28c445;
}

.status-gray {
  color: #9d9d9d;
}

.card-body {
  display: flex;
  padding-bottom: 32px;
  padding-top: 20px;
  align-items: center;
}

.img-box {
  width: 132px;
  height: 132px;
  margin-right: 26px;
  border-radius: 12px;
  overflow: hidden;
  flex-shrink: 0;
}

.img-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.info-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.row-deposit {
  margin-bottom: 24px;
  display: flex;
  align-items: baseline;
}

.row-deposit .label {
  font-size: 30px;
  color: #24262b;
  margin-right: 12px;
}

.row-deposit .amount {
  font-size: 34px;
  color: var(--primary-color);
  font-weight: bold;
}

.row-term {
  font-size: 30px;
  color: #24262b;
}

.empty-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 200px;

  .empty-icon {
    width: 342px;
    height: 264px;
  }
  .empty-text {
    font-size: 30px;
    color: #848992;
    margin-top: 40px;
  }
}

/deep/ .van-list__finished-text {
  font-size: 24px;
  color: #ccc;
  padding: 30px 0;
}
</style>
